import "esbuild-css-modules-plugin-ns-css:src/js/pages/descriptionStep/descriptionStep.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/descriptionStep/descriptionStep.module.css:injector.js";
export default new Proxy({
  "helpText": "descriptionStep-module__helpText_4ae2tG__1100",
  "pageContainer": "descriptionStep-module__pageContainer_4ae2tG__1100",
  "radioButtonContainer": "descriptionStep-module__radioButtonContainer_4ae2tG__1100",
  "selectText": "descriptionStep-module__selectText_4ae2tG__1100",
  "title": "descriptionStep-module__title_4ae2tG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      